// Tin mới sản phẩm — client HTTP dùng chung Core + Work.
//
// Hai host cùng một đường: Core `/api/product-news/*`, Work `/api/v1/product-news/*` —
// `@host/axios` đã gắn sẵn baseURL (`/api` | `/api/v1`) nên ở đây chỉ viết phần đuôi.
// Nguồn dữ liệu KHÁC nhau: Core đọc bảng gốc (nơi soạn bài), Work đọc bản sao đồng bộ từ Core
// mỗi phút. Hình dạng trả về giống hệt nhau — đó là hợp đồng, xem đầu productNewsStore.js.
import api from '@host/axios';

const BASE = '/product-news';

// Core bọc `{ success, data }`, Work bọc `{ data }` — gỡ một lớp cho cả hai.
const unwrap = (r) => (r?.data && Object.prototype.hasOwnProperty.call(r.data, 'data') ? r.data.data : r?.data);

/**
 * Danh sách tin đã đăng (mới nhất trước) + số chưa đọc. Con trỏ trang sau = (published_at, id)
 * của dòng cuối — cặp đôi để hai bài đăng CÙNG một thời điểm không bị nuốt mất một bài.
 */
export const fetchFeed = ({ limit = 20, before = null, beforeId = null, kind = null, unread = false } = {}) =>
  api.get(`${BASE}/feed`, {
    params: {
      limit,
      ...(before ? { before } : {}),
      ...(before && beforeId ? { before_id: beforeId } : {}),
      ...(kind ? { kind } : {}),
      ...(unread ? { unread: 1 } : {}),
    },
  }).then(unwrap);

export const fetchUnreadCount = () => api.get(`${BASE}/unread-count`).then((r) => Number(unwrap(r)?.count) || 0);

/** Một bài đầy đủ (kèm nội dung HTML) — chỉ bài đã đăng cho hệ này. */
export const fetchNews = (id) => api.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap);

export const markNewsRead = (id) => api.post(`${BASE}/${encodeURIComponent(id)}/read`).then(unwrap);

export const markAllNewsRead = () => api.post(`${BASE}/read-all`).then(unwrap);
